// Module
var code = "<div class=\"project-view\"> <div ui=\"declinedModal\"></div> <div ui=\"mainNav\"></div> <div class=\"project-view-frame-container\"> <iframe ng-src=\"{{url | trustAsResourceUrl}}\" class=\"project-view-iframe\" ng-class=\"{'project-view-iframe--with-info-banner': hasInfoBanner}\"> </iframe> </div> </div> ";
// Exports
var _module_exports = code;;
var path = 'ProjectView/ProjectView.ng.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;